<h2 mat-dialog-title class="dialog-title">Reset Device Care Settings</h2>
<form [formGroup]="resetDeviceCareSettingsForm">
    <div mat-dialog-content>
        <div class="mb-2">Are you sure you want to reset the Device Care settings back to default?</div>
        <div class="mt-2 text-warning">This operation cannot be undone!</div>
    </div>
    <div class="footer-wrapper" mat-dialog-actions>
        <button mat-button mat-dialog-close>CANCEL</button>
        <button color="warn" mat-button (click)="resetSettings()">RESET</button>
    </div>
</form>
